import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, CssBaseline, TextField, Button, Typography, Box, Grid } from '@mui/material';
import { useAuth } from '../useAuth';
import { login, verifyTfaCode, storeSession } from '../auth';
import { tokens } from '../theme';

const LoginPage: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [tfaToken, setTfaToken] = useState('');
  const [showTfaCode, setShowTfaCode] = useState(false);
  const [tfaCode, setTfaCode] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tfa = params.get("tfa") === "true"; // Convert to boolean
    setShowTfaCode(tfa)
  }, []);

  const { isAuthenticated, setIsAuthenticated } = useAuth();


  const handleLogin = async () => {
    try {
      const response = await login(username, password);
      switch (response.data.token_type) {
        case "tfa":
          setTfaToken(response.data.access_token);
          setShowTfaCode(true);
          navigate('/login?tfa=true');
          break;
        default:
          storeSession(response.data);
          setIsAuthenticated(true);
          navigate('/');
      }
    } catch (error) {
      console.error('Login failed:', error);
      alert('Login failed!');
    }
  };

  const handleTfaCode = async () => {
    const response = await verifyTfaCode(tfaToken, tfaCode);

    if (response.data.access_token) {
      storeSession(response.data);
      setIsAuthenticated(true);
      setShowTfaCode(false);
      navigate('/');
    }
  };


if (showTfaCode) {return <Container component="main" maxWidth="xs">
  <CssBaseline />
  <Box
    sx={{
      marginTop: 8,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      border: `1px solid ${tokens.hairline}`,
      padding: 4,
    }}
  >
    <Typography sx={{ color: tokens.mute, mb: 1 }}>[ auth ]</Typography>
    <Typography component="h1" variant="h5">
      [ VERIFY 2FA ]
    </Typography>
    <Box component="form" onSubmit={(e) => { e.preventDefault(); handleTfaCode(); }} sx={{ mt: 1 }}>
      <TextField
        margin="normal"
        required
        fullWidth
        id="code"
        label="Code"
        name="code"
        autoComplete="code"
        autoFocus
        value={tfaCode}
        onChange={(e) => setTfaCode(e.target.value)}
      />
     
      <Button
        type="submit"
        fullWidth
        variant="contained"
        sx={{ mt: 3, mb: 2 }}
      >
        Verify
      </Button>
    </Box>
  </Box>
</Container>} else {

  return  <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          border: `1px solid ${tokens.hairline}`,
          padding: 4,
        }}
      >
        <Typography sx={{ color: tokens.mute, mb: 1 }}>[ auth ]</Typography>
        <Typography component="h1" variant="h5">
          [ SIGN IN ]
        </Typography>
        <Box component="form" onSubmit={(e) => { e.preventDefault(); handleLogin(); }} sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="username"
            label="Username"
            name="username"
            autoComplete="username"
            autoFocus
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Sign In
          </Button>
        </Box>
      </Box>
    </Container>
        
    }
    

};

export default LoginPage;
